//let url = "192.168.40.129";
let url = window.location.href.split("//")[1].split("/")[0].split(":")[0]
//let url = "10.0.30.44";
if (url != 'localhost' && url.indexOf('192') == -1) {
    url = "api.jaysahakar.com"
}
let remoteip = "https://" + url+ ":5378";
let socketip = "https://" + url + ":5378";

export {remoteip,socketip}